export interface LikeStateOptions {
  animate?: boolean;
}

export interface CommitOptimisticLikeOptions {
  isLiked: boolean;
  setLikeState: (liked: boolean, options?: LikeStateOptions) => void;
  like: () => Promise<void>;
  unlike: () => Promise<void>;
  onLiked?: () => void;
  onError?: () => void;
}

export async function commitOptimisticLike({
  isLiked,
  setLikeState,
  like,
  unlike,
  onLiked,
  onError,
}: CommitOptimisticLikeOptions): Promise<boolean> {
  const previousLiked = isLiked;
  const nextLiked = !previousLiked;

  setLikeState(nextLiked, { animate: nextLiked });

  try {
    if (nextLiked) {
      await like();
      onLiked?.();
    } else {
      await unlike();
    }

    return nextLiked;
  } catch (error) {
    setLikeState(previousLiked);
    onError?.();

    throw error;
  }
}
